import React, { useCallback, useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { Bar } from '@ant-design/plots';
import CustomCard from '@components/CustomCard';

type BarComponentProps = {
  dataBar: any;
  formatLabels: any;
  setSearchParams: any;
  title: string;
  color: string;
  field: string;
};

export const SecondBarComponent = ({
  dataBar,
  formatLabels,
  setSearchParams,
  title,
  color,
  field,
}: BarComponentProps) => {
  const { t: translate } = useTranslation('roaming');

  const dataFormat = useMemo(() => dataBar, [dataBar]);

  const findRealName = useCallback(
    (titleToSearch: string) => {
      const findItemProduct = dataFormat?.find((item: any) =>
        item?.key?.includes(titleToSearch?.slice(0, -3)),
      );
      return findItemProduct;
    },
    [dataFormat],
  );
  return (
    <CustomCard title={translate(title)}>
      <Bar
        data={dataFormat}
        xField="value"
        yField="key"
        legend={false}
        scrollbar={{
          type: 'vertical',
        }}
        label={{
          content: (contentData: any) => formatLabels(contentData.value),
        }}
        color={color}
        meta={{
          value: {
            alias: translate('table.telephone'),
          },
          key: {
            formatter(value: any) {
              return `${value.slice(0, 20)}...`;
            },
          },
        }}
        tooltip={{
          title(titleBar) {
            return findRealName(titleBar)?.key || '';
          },
        }}
        onReady={plot => {
          plot.on('plot:click', (evt: any) => {
            const { x, y } = evt;
            const tooltipData = plot.chart.getTooltipItems({
              x,
              y,
            });
            setSearchParams({
              [field]: tooltipData[0].title,
            });
          });
        }}
        barStyle={{
          radius: [6, 6, 0, 0],
        }}
      />
    </CustomCard>
  );
};
